<div class="row">
	<div class="col-lg-10">
		<h1>Registered Applications</h1>
		<br>
	</div>
	<div class="col-lg-2 ">
		<button type="button" class="btn btn-primary cls" style="background-color: #2196f3;"
			(click)="gotoRegister()">Add New</button> </div>
</div>

<div class="dataTables_wrapper">
	<div style="width:100%;overflow-x:auto;">
		<table class="table table-bordered table-striped" datatable="ng" [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
			style="width:100%;">
			<thead class="thead-default">
				<tr>
					<th>Application Name</th>
					<th>API key</th>
					<th>Cyberscore Threshold</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let application of customerApplications">
					<td (click)="goDetails(application)">{{application.applicationName}}</td>
					<td (click)="goDetails(application)">{{application.apiKey}}</td>
					<td (click)="goDetails(application)">{{application.cyberScoreThreshold}}</td>
					<td><span>
							<button type="button" *ngIf="application.isEnabled" class="btn btn-warning btn-sm cls"
								style="background-color: #ff9800" (click)="update(application)">Disable</button>
							<button type="button" *ngIf="!application.isEnabled" class="btn btn-success btn-sm cls"
								style="background-color: #5ccd76" (click)="update(application)">
								Enable &nbsp;</button>
						</span><span>
							<button class="btn btn-danger btn-sm cls" style="background-color: #df3246"
								(click)="deleteApplication(application.id)">Delete</button>
						</span></td>
				</tr>
			</tbody>
		</table>
	</div>
</div>